import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { CheckBox as CheckBoxIcon } from '@mui/icons-material';
import { Colors } from '../../../assets/theme/Colors';

const CourseModuleItem = ({ onClick, icon, title, duration, done = false }) => (
  <Box py={1} onClick={onClick} width="100%" display="flex" alignItems="center" justifyContent="space-between">
    <Button variant="outlined" fullWidth sx={{ textTransform: 'none', justifyContent: 'space-between' }}>
      <Box display="flex" alignItems="center">
        {icon}
        <Typography style={{ marginLeft: '1rem' }} variant="subtitle2">
          {title} {duration ? `- ${duration} min` : ''}
        </Typography>
      </Box>
      {!!done && <CheckBoxIcon sx={{ color: Colors.green.light }} />}
    </Button>
  </Box>
);

export default CourseModuleItem;
